module.exports = __webpack_public_path__ + "media/images/sp/brands/an/store_an-874a9c4776a1a84ed4b36815f1622c47.jpg";